const domLoaded = (callback) => {
  document.removeEventListener("DOMContentLoaded", domLoaded);
  window.removeEventListener("load", domLoaded);
  callback();
};

export const addDomLoadedCallback = (callback) => {
  if (typeof document !== "undefined" && document.readyState !== "loading") {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", domLoaded.bind(null, callback));
    window.addEventListener("load", domLoaded.bind(null, callback));
  }
};
